import { useStore } from '@nanostores/react'
import { useState } from 'react'
import {
  TRIAL_REMINDER_GROUPS,
  type TrialReminderGroup,
} from '~/features/multi-page/lib/trial-reminder'
import {
  $debugAfterPaymentError,
  $debugAfterPaymentErrorSilent,
  $debugExperimentGroupOverride,
} from '~/store/debug'

function parseExperimentGroup(value: string): TrialReminderGroup | null {
  return TRIAL_REMINDER_GROUPS.find((group) => group === value) ?? null
}

export function DevTools() {
  const [isOpen, setIsOpen] = useState(false)
  const debugAfterPaymentError = useStore($debugAfterPaymentError)
  const debugAfterPaymentErrorSilent = useStore($debugAfterPaymentErrorSilent)
  const experimentGroupOverride = useStore($debugExperimentGroupOverride)

  return (
    <div className="fixed left-2 top-[calc(8px+var(--safe-area-top))] z-[9999]">
      {isOpen ? (
        <div className="flex flex-col gap-1 rounded-lg bg-black/80 p-2 text-xs text-white shadow-lg">
          <div className="mb-1 flex items-center justify-between gap-2">
            <span className="font-semibold">Dev Tools</span>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white/60 hover:text-white"
            >
              ✕
            </button>
          </div>

          <label className="flex cursor-pointer items-center gap-2">
            <input
              type="checkbox"
              checked={debugAfterPaymentError}
              onChange={(e) =>
                $debugAfterPaymentError.set(e.currentTarget.checked)
              }
              className="h-4 w-4 cursor-pointer"
            />
            <span className="select-none">Simulate AfterPaymentError</span>
          </label>

          <label className="flex cursor-pointer items-center gap-2">
            <input
              type="checkbox"
              checked={debugAfterPaymentErrorSilent}
              onChange={(e) =>
                $debugAfterPaymentErrorSilent.set(e.currentTarget.checked)
              }
              className="h-4 w-4 cursor-pointer"
            />
            <span className="select-none">
              Simulate AfterPaymentError (silent — test Restore button)
            </span>
          </label>

          <label className="flex items-center justify-between gap-2">
            <span className="select-none">Force experiment group</span>
            <select
              value={experimentGroupOverride ?? ''}
              onChange={(e) =>
                $debugExperimentGroupOverride.set(
                  parseExperimentGroup(e.currentTarget.value),
                )
              }
              className="rounded bg-white/20 px-1 py-0.5 text-white"
            >
              <option value="">no override</option>
              {TRIAL_REMINDER_GROUPS.map((group) => (
                <option key={group} value={group}>
                  {group}
                </option>
              ))}
            </select>
          </label>
        </div>
      ) : (
        <button
          onClick={() => setIsOpen(true)}
          className="rounded-full bg-black/80 px-3 py-1.5 text-xs font-medium text-white shadow-lg"
        >
          Dev
        </button>
      )}
    </div>
  )
}
